<template>
  <div class="mb-3" :class="{ error: !!field.error }">
    <label
      :for="field.id"
      class="form-label"
      :class="{ 'text-danger': !!field.error }"
      >{{ field.name + (field.required ? '*' : '') }}
      <Tooltip
        v-show="!!field.tooltipInfo"
        :id="field.id"
        :info="field.tooltipInfo"
      />
    </label>

    <p style="display:none">{{ field.value }}</p>
    <b-form-radio-group
      :options="field.options"
      class="mb-4 custom-radio-group shadow-none"
      v-model="selected"
      @change="onChange($event)"
      size="lg"
    ></b-form-radio-group>
  </div>
</template>

<script>
import Tooltip from '../global/Tooltip.vue';

export default {
  name: 'RadioField',
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  components: {
    Tooltip,
  },
  mounted() {
    this.selected = this.field.value;
  },
  methods: {
    onChange($event) {
      this.$emit('input', $event);
    },
  },
  data() {
    return {
      selected: '',
    };
  },
  updated() {
    this.selected = this.field.value;
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  border: none;
}
.form-label {
  font-size: 20px;
}

.custom-radio-group::v-deep .custom-control {
  font-size: 12px;
  .custom-control-label {
    margin-right: 50px;
    padding-top: 4px;
    border: 0;
    box-shadow: none;
    &::after {
      transform: translate(25%, 25%);
      width: 0.65rem;
      height: 0.65rem;
    }
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: transparent;
    box-shadow: none;
  }
}

.custom-radio-group::v-deep {
  .custom-control-input:checked ~ .custom-control-label::after {
    background: $primary;
    border-radius: 50%;
    box-shadow: none;
  }
  .custom-control-input:focus {
    box-shadow: none;
  }
}
.custom-radio-group:focus,
.custom-radio-group:active {
  outline: none !important;
  box-shadow: none;
}
.error {
  border: $danger;
}
</style>
